import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_TOURNAMENT } from '@/modules/tournament/router';
import { tournamentService } from '@/services/tournament';
import useVuelidate from '@vuelidate/core';
import { integer, minValue, required } from '@vuelidate/validators';
import { reactive } from 'vue';

export function useTournamentMedalAdd() {
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const model = reactive({
        name: '',
        rank: null,
        imageFile: null
    });

    const validations = {
        name: { required },
        rank: { required, integer, min: minValue(0) }
    };

    const v$ = useVuelidate(validations, model);

    const create = crudAction.excuteAndNotify({
        validator: v$,
        request: () => tournamentService.medal.create(model.name, model.rank, model.imageFile),
        onSuccess: () => router.push({ name: ROUTE_NAME_TOURNAMENT.MEDAL.INDEX })
    });

    return { model, v$, create };
}
